import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Box, Flex, Card, Link } from '@cowsquare/design';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import * as R from 'ramda';
import { Advertisements } from '../../../Advertisements';
import { Section } from '../../../Section';
import { Title } from '../../../Title';
import { Loading, LinkCardListLoading } from '../../../Loading';
import { useAdsQuery } from '../../../../utils/hooks';

const SubTitle = styled.h3`
  font-size: 16px;
  line-height: 1.5;
  font-weight: normal;
  margin: 0;
`;

const CardFlex = styled(Flex).attrs({
  flexWrap: 'wrap',
})`
  margin: 0 -8px;
`;

const CardBox = styled(Box).attrs({
  width: [1, 1 / 3],
  px: 4,
  pb: 5,
})``;

const GET_TOOLS = gql`
  query {
    categories: hkdutest_edrug_tools_categories {
      id
      name
      tools {
        id
        url
        name
      }
    }
  }
`;

const Tools = ({ uri }) => {
  const { ads } = useAdsQuery(uri);

  return (
    <Section>
      <Helmet>
        <title>Tools - HKDU E-Pharm</title>
      </Helmet>
      <Advertisements ads={ads} />
      <Box width="100%" px={['20px', 0]} py={8}>
        <Flex flexDirection="column">
          <Title>Tools</Title>
          <Query query={GET_TOOLS}>
            {({ data, loading }) => {
              if (loading) {
                return (
                  <React.Fragment>
                    <Box mt={25} mb={20}>
                      <Loading width="120px" height="12px" />
                    </Box>
                    <LinkCardListLoading />
                  </React.Fragment>
                );
              }
              return R.pipe(
                R.propOr([], 'categories'),
                R.map(category => (
                  <React.Fragment key={category.id}>
                    <Box mt={25} mb={20}>
                      <SubTitle>{category.name}</SubTitle>
                    </Box>
                    <CardFlex>
                      {R.pipe(
                        R.propOr([], 'tools'),
                        R.map(tool => (
                          <CardBox key={tool.id}>
                            <Card target="_blank" height="120px" href={R.pathOr('', ['url'], tool)}>
                              <Card.Meta title={tool.name}>
                                <Link.Group>
                                  <Link icon="LINK" as="span" />
                                </Link.Group>
                              </Card.Meta>
                            </Card>
                          </CardBox>
                        ))
                      )(category)}
                    </CardFlex>
                  </React.Fragment>
                ))
              )(data);
            }}
          </Query>
        </Flex>
      </Box>
    </Section>
  );
};

export default Tools;
